var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#20242E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4812 17.1488L21.3444 21.7909L19.9018 23.0139L21.3443 24.2402L27.4811 28.8791C27.8755 29.1779 28.0434 29.6245 27.9218 30.0509C27.8002 30.4774 27.4074 30.8187 26.8914 30.9466C26.3755 31.0744 25.8147 30.9691 25.4204 30.6705L16.4799 23.9095C16.1737 23.678 16 23.3535 16 23.0139C16 22.6743 16.1737 22.3499 16.4799 22.1184L25.4204 15.3607C25.7094 15.1251 26.1043 14.9948 26.514 15.0002C26.9236 15.0053 27.3132 15.1454 27.5931 15.3882C27.8729 15.6311 28.0193 15.9557 27.998 16.2879C27.9769 16.62 27.7902 16.9308 27.4812 17.1488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.6f717fc9555750dd24c28c39b77f59b8.svg";
export { ForwardRef as ReactComponent };